module.exports = __webpack_public_path__ + "worldstream/media/du.5a9d21e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Audio/du.mp3
// module id = jK+s
// module chunks = 1